// Document status constants based on Django backend
export const INVOICE_STATUS_CHOICES = [
  { value: "draft", label: "Draft" },
  { value: "sent", label: "Sent" },
  { value: "paid", label: "Paid" },
  { value: "overdue", label: "Overdue" },
  { value: "cancelled", label: "Cancelled" },
] as const;

export const CREDIT_NOTE_STATUS_CHOICES = [
  { value: "draft", label: "Draft" },
  { value: "sent", label: "Sent" },
  { value: "applied", label: "Applied" },
  { value: "cancelled", label: "Cancelled" },
] as const;

export const DOWN_PAYMENT_STATUS_CHOICES = [
  { value: "draft", label: "Draft" },
  { value: "sent", label: "Sent" },
  { value: "paid", label: "Paid" },
  { value: "applied", label: "Applied" },
  { value: "cancelled", label: "Cancelled" },
] as const;

export const CREDIT_NOTE_REASON_CHOICES = [
  { value: "invoice_cancelled", label: "Invoice Cancelled" },
  { value: "billing_error", label: "Billing Error" },
  { value: "service_not_provided", label: "Service Not Provided" },
  { value: "client_dispute", label: "Client Dispute" },
  { value: "refund_request", label: "Refund Request" },
  { value: "other", label: "Other" },
] as const;

export type InvoiceStatus = typeof INVOICE_STATUS_CHOICES[number]['value'];
export type CreditNoteStatus = typeof CREDIT_NOTE_STATUS_CHOICES[number]['value'];
export type DownPaymentStatus = typeof DOWN_PAYMENT_STATUS_CHOICES[number]['value'];
export type CreditNoteReason = typeof CREDIT_NOTE_REASON_CHOICES[number]['value'];
